// extracted by mini-css-extract-plugin
export default {"qsEntries":"qsEntries--w0A3U","entry":"entry--h8SC7","logo":"logo--vkoWd","title":"title--bed-x","link":"link--LraTd"};